import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const TableTop = styled(Flex)`
 padding: ${props => (props?.padding === false ? '0' : '5px 20px 0px 20px')};
  border: ${props =>
    props?.border ? 'none' : `1px solid ${COLORS.GREY_T_90}`};
  border-top: ${props =>
    props?.border ? 'none' : `1px solid ${COLORS.GREY_T_90}`};
  background: ${props => (props?.backgroundColor ? 'white' : '')};
`
